import React from "react";
import AlmostThere from "../../components/auth/AlmostThere";

export default function AlmostTherePage() {
  return <AlmostThere />;
}
